export const DIRECTORS = [
  {
    name: 'Anil Shah',
    role: 'Founding Chairman',
    image: '/images/directors/anil-shah.png',
    linkedin: 'https://www.linkedin.com/in/anil-shah-82720443/',
  },
  {
    name: 'Sivakumar Kota',
    role: 'Director',
    image: '/images/directors/chintan-shah.png',
    linkedin: 'https://www.linkedin.com/in/sivakumar-kota-70260a19/',
  },
  {
    name: 'Chintan Shah',
    role: 'Treasurer',
    image: '/images/directors/sivakumar-kota.png',
    linkedin: 'https://www.linkedin.com/in/chintan-shah-1687a5121/',
  },
  {
    name: 'Jeetendra Jodhpurkar',
    role: 'Secretary',
    image: '/images/directors/jeetendra-jodhpurkar.png',
    linkedin: 'https://www.linkedin.com/in/jodhpurkar/',
  },
];
